require('./sass/styles.scss');

import 'babel-polyfill';
import React from 'react';
import ReactDom from 'react-dom';
import {Provider} from 'react-redux';
import {Router, Route, Switch} from 'react-router-dom';
import {createBrowserHistory} from 'history';

import {createStore, compose, applyMiddleware} from 'redux';
import thunk from 'redux-thunk';
import promise from 'redux-promise-middleware';
import {createLogger} from 'redux-logger';
import {routerMiddleware, connectRouter, ConnectedRouter} from 'connected-react-router';

import rootReducer from './reducers';

const siteBaseUrl = RT_API.baseUrl.replace(['http://','https://'],'').replace(window.location.origin.replace(['http://','https://'],''), '');
//console.log(RT_API);
const history = createBrowserHistory({basename: siteBaseUrl});
const store = createStore(
	connectRouter(history)(rootReducer),
	compose(
		applyMiddleware(
			routerMiddleware(history),
			promise(),
			thunk,
			createLogger()
		)
	)
);

import Mapper from './containers/mapper';
import MapperF2F from './containers/mapper-ford-to-ford';
import MapperTMM from './containers/mapper-taverns-mills-militia';
import MapperTOP from './containers/mapper-testimony-of-peace';
import MapperCB from './containers/mapper-covered-bridges';
import MapperCity from './containers/mapper-city';
import MapperCategory from './containers/mapper-category';
import Blog from './containers/blog';
import Events from './containers/events';
import WalkingTour from './containers/walkingtour';
import WalkingTourTest from './containers/walkingtourtest';
import Search from './containers/search';
import Category from './containers/category';
import Tag from './containers/tag';
import Single from './containers/single';

ReactDom.render(
	<Provider store={store}>
		<ConnectedRouter history={history}>
			<Switch>
				<Route exact path="/" component={Blog}/>
				<Route exact path="/explore-chester-county/map-view" component={Mapper}/>
				<Route exact path="/home/battle-of-the-brandywine/ford-to-ford/ford-to-ford-virtual-tour/" component={MapperF2F} />
				<Route exact path="/home/battle-of-the-brandywine/taverns-mills-militia/taverns-mills-militia-virtual-tour/" component={MapperTMM} />
				<Route exact path="/home/battle-of-the-brandywine/testimony-of-peace/testimony-of-peace-virtual-tour/" component={MapperTOP} />
				<Route exact path="/home/village-walking-tours" component={WalkingTour} />
				<Route exact path="/home/village-walking-tour-test" component={WalkingTourTest} />
				<Route exact path="/maps/covered-bridges" component={MapperCB} />
				<Route exact path="/maps/west-chester" component={MapperCity} />
				<Route exact path="/maps/kennett-square" component={MapperCity} />
				<Route exact path="/maps/phoenixville" component={MapperCity} />
				<Route exact path="/maps" component={MapperCategory}/>
				<Route exact path="/events" component={Events}/>
				<Route path="/page/:pageNum" component={Blog}/>
				<Route path="/:slug/page/" component={Blog}/>
				<Route path="/search/:term" component={Search}/>
				<Route path="/category/:slug/page/:pageNum" component={Category}/>
				<Route path="/category/:slug/" component={Category}/>
				<Route path="/category/:parent/:slug/page/:pageNum" component={Category}/>
				<Route path="/category/:parent/:slug/" component={Category}/>
				<Route path="/tag/:slug/page/:pageNum" component={Tag}/>
				<Route path="/tag/:slug" component={Tag}/>
				<Route path="*" component={Single}/>
			</Switch>
		</ConnectedRouter>
	</Provider>,
	document.getElementById('react-main')
);



// WEBPACK FOOTER //
// ./src/index.js